import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  output,
  type InputSignal,
  type OutputEmitterRef,
  type Signal,
} from '@angular/core';

@Component({
  selector: 'ui-section',
  imports: [],
  templateUrl: './ui-section.component.html',
  styleUrl: './ui-section.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UiSectionComponent {
  public readonly title: InputSignal<string> = input.required<string>();
  public readonly eyebrow: InputSignal<string | null> = input<string | null>(null);
  public readonly description: InputSignal<string | null> = input<string | null>(null);
  public readonly actionLabel: InputSignal<string | null> = input<string | null>(null);
  public readonly actionRequested: OutputEmitterRef<void> = output<void>();

  protected readonly hasEyebrow: Signal<boolean> = computed((): boolean => !!this.eyebrow());
  protected readonly hasDescription: Signal<boolean> = computed((): boolean => !!this.description());
  protected readonly hasAction: Signal<boolean> = computed((): boolean => !!this.actionLabel());

  protected handleActionRequested(): void {
    this.actionRequested.emit();
  }
}
